/* What the master pane draws instead of rows: the wait, the failure, the empty library, and the
 * search that matched nothing.
 *
 * All four stand in the SAME box the rows would have filled — `flex: 1, min-height: 0` inside the
 * pane's card, so the card's own height never changes with its state. That is the loading policy's
 * first rule: a box knows its size before its data arrives, so the answer landing changes ink and
 * never geometry.
 *
 * KANON views 09 (empty) and 10 (no results) are drawn full width in the earlier library canon; at
 * 461px their 34px display word and their eyebrow do not fit, so the three worded states are
 * `shared/ui/EmptyState` at this pane's scale. What survives is the canon's composition — a mark, a
 * sentence, and the one way out of the state — and its copy, unchanged.
 *
 * The centred box and the two buttons under it moved to `shared/ui/listState.module.css` on
 * 17 September 2026, on the exercise library. What is left here is this list's own SKELETON, which
 * is the shape of its own rows.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

/* ── The wait ────────────────────────────────────────────────────────────────────────────────
 * Rows in the shape of the rows they are about to be, on the row's own height and inset, so the
 * bars appearing and the plans arriving are both changes of ink inside a box that never moves. */

.skeletonList {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.skeletonRow {
  display: grid;
  grid-template-columns: var(--w-pl-cover) minmax(0, 1fr) auto;
  gap: var(--space-9-5px);
  align-items: center;
  height: var(--h-pl-row);
  padding: var(--space-0) var(--space-11px);
  border-bottom: var(--border-hairline) solid var(--border);
}

/* The same 8px corner the real cover wears since D28, not the canon's 6.5: the wait is drawn as the
 * row it is about to be, and a skeleton with a different radius is a shape that changes on arrival. */
.skeletonCover {
  width: var(--w-pl-cover);
  height: var(--h-pl-cover);
  border-radius: var(--radius-8px);
}

.skeletonIdentity {
  display: flex;
  flex-direction: column;
  gap: var(--space-6px);
  min-width: 0;
}

.skeletonName {
  width: 62%;
  height: 11px;
}

.skeletonSub {
  width: 44%;
  height: 8px;
}

/* The mode mark's own 16px square: the template row ends on the mark alone since the owner's
 * polish of 4 November 2026, so its wait does too. */
.skeletonMode {
  width: 16px;
  height: 16px;
}

